/* eslint-disable promise/avoid-new */
/* eslint-disable @typescript-eslint/no-explicit-any */

import type { Writable } from 'type-fest';

export type Deferred<T = any> = Readonly<{
	promise: Promise<T>;
	resolve: (value: T) => void;
	reject: (error: any) => void;
}>;

export function defer<T = any>(): Deferred<T> {
	const deferred = {} as Writable<Deferred<T>>;
	const promise = new Promise<T>((resolve, reject) => {
		deferred.resolve = resolve;
		deferred.reject = reject;
	});
	deferred.promise = promise;
	return deferred;
}
